import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { HeroVisual } from "./HeroVisual";
import { useLang } from "../context/LanguageContext";
import { Button } from "./ui/button";

export default function Hero() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [url, setUrl] = useState("");

  const submit = (e) => {
    e.preventDefault();
    navigate("/studio", { state: { url } });
  };

  return (
    <section className="relative overflow-hidden grid-bg pt-28 pb-16 sm:pt-36 sm:pb-24">
      <div className="max-w-5xl mx-auto px-5 text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-yellow-400/10 border border-yellow-400/20 text-yellow-300 text-xs font-semibold mb-7 animate-fade-up">
          <Sparkles className="h-3.5 w-3.5" />
          AI Clipping · Viral Score
        </div>

        <h1 className="text-4xl sm:text-6xl lg:text-7xl font-extrabold leading-[1.05] tracking-tight animate-fade-up">
          {t("hero_title_1")}{" "}
          <span className="text-gradient-yellow block sm:inline">{t("hero_title_2")}</span>
        </h1>

        <p className="mt-6 text-lg sm:text-xl text-zinc-400 max-w-2xl mx-auto animate-fade-up">
          {t("hero_sub")}
        </p>

        <form
          onSubmit={submit}
          className="mt-9 max-w-xl mx-auto flex flex-col sm:flex-row gap-2.5 p-2 bg-zinc-900/80 border border-white/10 rounded-2xl backdrop-blur animate-fade-up"
        >
          <input
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder={t("hero_placeholder")}
            className="flex-1 bg-transparent px-4 py-3 text-sm sm:text-base text-white placeholder:text-zinc-500 focus:outline-none"
          />
          <Button
            type="submit"
            className="bg-yellow-400 hover:bg-yellow-300 text-zinc-950 font-bold rounded-xl px-6 py-6 text-base shadow-[0_0_30px_-6px_rgba(250,204,21,0.6)]"
          >
            {t("hero_cta")}
            <ArrowRight className="h-4 w-4 ml-1.5" />
          </Button>
        </form>

        <div className="mt-4 flex flex-col items-center gap-2 animate-fade-up">
          <p className="text-xs text-zinc-500">{t("hero_note")}</p>
        </div>
      </div>

      <HeroVisual />
    </section>
  );
}
